import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const RecentContentTable = ({ content }) => {
  const navigate = useNavigate();

  const getStatusBadge = (status) => {
    const statusConfig = {
      published: { class: 'badge-success', icon: 'CheckCircle2' },
      draft: { class: 'badge-default', icon: 'FileText' },
      pending: { class: 'badge-warning', icon: 'Clock' },
      archived: { class: 'badge-error', icon: 'Archive' }
    };

    const config = statusConfig?.[status] || statusConfig?.draft;

    return (
      <span className={`badge ${config?.class}`}>
        <Icon name={config?.icon} size={14} />
        {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
      </span>
    );
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleRowClick = (contentId) => {
    navigate(`/event-management/${contentId}`);
  };

  return (
    <div className="card overflow-hidden">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-foreground">Recent Content</h2>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Title
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Author
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Last Modified
              </th>
            </tr>
          </thead>
          <tbody className="bg-card divide-y divide-border">
            {content?.map((item) => (
              <tr 
                key={item?.id}
                className="hover:bg-muted/30 transition-colors duration-200 cursor-pointer"
                onClick={() => handleRowClick(item?.id)}
              >
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${item?.iconColor}`}>
                      <Icon name={item?.icon} size={20} />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground">{item?.title}</p>
                      <p className="text-xs text-muted-foreground">{item?.category}</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <p className="text-sm text-foreground">{item?.author}</p>
                </td>
                <td className="px-6 py-4">
                  {getStatusBadge(item?.status)}
                </td>
                <td className="px-6 py-4">
                  <p className="text-sm text-muted-foreground">{formatDate(item?.lastModified)}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentContentTable;